/**
 * List Controller
 */
(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.controller('CampaignActivityController', [
        '$scope',
        '$timeout',
        'campaignApi',
        'optionsApi',
        function($scope, $timeout, campaignApi, optionsApi) {
            // select search input content on focus
            $('#search').click(function() {
                $(this).select();
            });

            $scope.loading = false;

            $scope.statusFilter = ['running'];

            $scope.$watch('statusFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    $scope.fetch();
                }
            }, true);

            $scope.list = null;

            $scope.page = {
                number: 0,
                size: 500,
            };

            var storedSearchTerm = window.localStorage.getItem('campaignSearchTerm');
            if (storedSearchTerm) {
                $scope.searchTerm = storedSearchTerm;
            } else {
                $scope.searchTerm = '';
            }

            var storedSelectedIo = parseInt(window.localStorage.getItem('ioFilter'));
            if (storedSelectedIo) {
                $scope.ioFilter = storedSelectedIo;
            } else {
                $scope.ioFilter = window.selectedIo ? window.selectedIo : '*';
            }

            $scope.sort = {
                field: 'ts_updated',
                order: 'desc',
            };

            /**
             * If user presses enter in search box perform the search
             * @param e
             */
            $scope.checkSubmit = function(e) {
                if (e.originalEvent.charCode === 13) {
                    $scope.search();
                }
            };

            $scope.filter = function() {
                $scope.page.number = 0;

                $scope.fetch();
            };

            var filterTimeout = null;
            $scope.$watch('searchTerm', function(newVal, oldVal) {
                if (newVal == oldVal) {
                    return;
                }

                window.localStorage.setItem('campaignSearchTerm', $scope.searchTerm);

                if (filterTimeout) {
                    $timeout.cancel(filterTimeout);
                }

                filterTimeout = $timeout(function() {
                    $scope.filter();
                }, 700);
            });

            $scope.$watch('ioFilter', function(newVal, oldVal) {
                if (newVal && oldVal && newVal !== oldVal) {
                    window.localStorage.setItem('ioFilter', $scope.ioFilter);
                    $scope.filter();
                }
            });

            $scope.filter = function() {
                $scope.page.number = 0;

                $scope.fetch();
            };

            /**
             * Fetch list data from server
             */
            $scope.fetch = function() {
                $scope.loading = true;

                campaignApi
                    .getActivityList($scope.sort, $scope.searchTerm, $scope.page, $scope.ioFilter, $scope.statusFilter)
                    .then(
                        function(data) {
                            $scope.list = {
                                count: data.count,
                                data: data.data,
                                maxPage: Math.floor(data.count / $scope.page.size),
                            };
                            if (data.data.length > 0) {
                                var cids = [];
                                for (var i = 0; i < data.data.length; i++) {
                                    cids.push(data.data[i]['_id']);
                                }
                                campaignApi.getCampaignStatCDP(cids).then(function (stat) {
                                    for (i = 0; i < $scope.list.data.length; i++) {
                                        var cid = $scope.list.data[i]['_id'];
                                        $scope.list.data[i].budget_spent = stat[cid] ? stat[cid].sum_cost / 1000000 : 0;
                                        $scope.list.data[i].ctr_stat = stat[cid] && stat[cid].impressionsTotal
                                            ? ((stat[cid].clicksTotal / stat[cid].impressionsTotal) * 100).toString()
                                            : '0';
                                        $scope.list.data[i].imps_stat = stat[cid] && stat[cid].impressionsStr ? stat[cid].impressionsStr : 'N/A';
                                        $scope.list.data[i].clicks_stat = stat[cid] && stat[cid].clicksStr ? stat[cid].clicksStr : 'N/A';
                                        $scope.list.data[i].stat =  stat[cid].stat;
                                        $scope.list.data[i].delivery_log =  stat[cid].log;

                                    }
                                });
                            }
                            $scope.loading = false;
                        },
                        function() {
                            $scope.list = {
                                count: 0,
                                data: [],
                                maxPage: null,
                            };
                            $scope.loading = false;
                        }
                    );
            };

            /**
             * set page to new value and load data
             * @param page
             */
            $scope.setPage = function(page) {
                $scope.page.number = page;

                $scope.fetch();
            };

            /**
             * get the sort css for a given column
             * @param field
             * @returns {*}
             */
            $scope.getSortCssClass = function(field) {
                if ($scope.sort.field === field) {
                    return 'fa-sort-' + $scope.sort.order;
                } else {
                    return 'fa-sort';
                }
            };

            /**
             * update sorting and fetch data
             * @param field
             */
            $scope.setSort = function(field) {
                $scope.page.number = 0;

                if ($scope.sort.field === field) {
                    $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
                } else {
                    $scope.sort.field = field;
                    $scope.sort.order = 'desc';
                }

                $scope.fetch();
            };

            /**
             * toggle active/inactive
             * @param campaign
             */
            $scope.toggleActive = function(campaign) {
                campaignApi.toggleActive(campaign._id).then(function() {
                    campaign.active = !campaign.active;
                });
            };

            /**
             * open a Campaign creating/editing form
             * @param campaignId
             */
            $scope.openCampaignForm = function(campaignId) {
                window.location.href = '/#!/demandmgr/campaign/edit?id=' + campaignId;
            };

            $scope.fetch();
        },
    ]);
})(window.angular);
